import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c(VRow,[_c(VCol,{staticClass:"py-0",attrs:{"cols":"12"}},[_c(VProgressCircular,{attrs:{"size":_vm.size,"color":"primary","indeterminate":""}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }